import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Result, Skeleton } from 'antd';
import styles from './index.module.scss';
import WarrantyInfoSuccess from '../WarrantyInfoSuccess';
import WarrantyInfoNotFound from '../WarrantyInfoNotFound';
import warrantyInfoIcon from '../../../../../assets/images/warranty-info-icon.png';

// Khối kết quả nằm ở cột phải của form (thay chỗ ảnh minh hoạ), không phải màn riêng.
const WarrantyResultPanel = ({ data, notFound, error, loading, serial, onRetry }) => {
  const { t } = useTranslation();

  // 429 là bị chặn vì tra quá nhanh, khác hẳn lỗi hệ thống nên phải nói rõ để người dùng biết chờ.
  // Không hiện số giây vì BE chưa expose x-ratelimit-reset qua CORS.
  const errorMessage = error?.status === 429 ? t('common.rateLimited') : t('warrantyLookup.lookupError');

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <img src={warrantyInfoIcon} alt="warranty-info" />
        {t('warrantyLookup.resultTitle')}
      </div>

      {loading && <Skeleton active paragraph={{ rows: 6 }} />}
      {!loading && error && (
        <Result
          status="error"
          title={t('warrantyLookup.errorTitle')}
          subTitle={errorMessage}
          extra={
            <Button type="primary" onClick={onRetry}>
              {t('warrantyLookup.errorRetry')}
            </Button>
          }
        />
      )}
      {!loading && !error && notFound && <WarrantyInfoNotFound serial={serial} />}
      {!loading && !error && !notFound && data && <WarrantyInfoSuccess data={data} />}
    </div>
  );
};

export default WarrantyResultPanel;
